/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import MutatorComponentBase from "./MutatorComponentBase";

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class BatchMutator extends MutatorComponentBase
{
    @property({ type: cc.Node })
    public get ConfigureAssetsForBatching(): cc.Node { return null; }
    public set ConfigureAssetsForBatching(target: cc.Node)
    {
        this.execute(target,
            [
                this.spriteHandler.bind(this),
                this.maskHandler.bind(this),
                this.spineHandler.bind(this)
            ]);
    }

    private spriteHandler(target: cc.Node): boolean
    {
        let success: boolean = false;
        let sprite: cc.Sprite = target.getComponent(cc.Sprite);

        if (!sprite) { return false; }

        if (sprite.srcBlendFactor !== 770)
        {
            this.warn(target, `Source blend factor: [${sprite.srcBlendFactor}].`);
            success = true;
        }

        if (sprite.dstBlendFactor !== 771)
        {
            this.warn(target, `Destination blend factor: [${sprite.dstBlendFactor}].`);
            success = true;
        }

        return success;
    }

    private maskHandler(target: cc.Node): boolean
    {
        let mask: cc.Mask = target.getComponent(cc.Mask);

        if (!mask) { return false; }

        this.warn(target, 'Has [[cc.Mask]] component.');
        return true;
    }

    private spineHandler(target: cc.Node): boolean
    {
        let spine: sp.Skeleton = target.getComponent(sp.Skeleton);

        if (!spine) { return false; }

        if (spine.premultipliedAlpha)
        {
            this.warn(target, 'Spine has pre-multiplied alpha.');
            return true;
        }

        return false;
    }
}
